
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-68973dac&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DetalhesFechamentoExtra.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetalhesFechamentoExtra.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-68973dac!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetalhesFechamentoExtra.vue"),
  /* scopeId */
  "data-v-68973dac",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/aplicacaoFechamentoExtra/DetalhesFechamentoExtra.vue
// module id = 882
// module chunks = 1